export default __webpack_public_path__ + "static/retirement-planning-9-39e539a890029bd33c5388e122520e10.png";